import { useEffect, useState } from "react";
import quoteService from "services/quote.service";
import Dropdown from "components/Dropdown";
import { getTruck } from "pages/Dashboard/utils";

const SearchSelection = ({
  unit,
  setUnit,
  setValue,
  checked,
  className,
  error,
  placeholderText,
  setTruckType,
  state
}) => {
  const [list, setList] = useState([]);

  const handleClick = ({ title }) => {
    getTruck({ title, setValue, setTruckType, state });
  };

  useEffect(() => {
    const unitValue = unit.name.title;
    setValue("unit", unitValue);

    unitValue.length > 1 && unitValue !== ""
      ? quoteService.getTrucksList({ truck_plate_number: unitValue, state }).then(
          ({ data }) => {
            let dropdownList
            if(state?.dispatched) {
              dropdownList = data?.map(({ unit }) => {
                return { title: unit, value: unit };
              });
            } else {
              dropdownList = data?.map(({ truck_plate_number }) => {
                return { title: truck_plate_number, value: truck_plate_number };
              });
            }
            setList(dropdownList);
          },
          ({ response }) => {
            console.error(response);
          },
        )
      : setList([]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [unit.name.title, setValue]);

  return (
    <>
      <Dropdown
        list={list}
        withInput={true}
        value={unit}
        setValue={setUnit}
        className={className}
        label={`Unit # ${checked ? "" : "*"}`}
        keyValue="name"
        error={error}
        placeholderText={placeholderText}
        handleClick={handleClick}
      />
    </>
  );
};

export default SearchSelection;
